export interface IReservation {
  id_reservation?: number;
  id_location: number;
  id_station: number;
  id_client?: number;
  id_user?: number;
  id_vehicle_type: number;
  license_plate: string;
  duration_minutes: number;
  energy_kwh?: number;          // odhad, dopočítává BE z duration × avg power vozidla
  date_from: Date;
  date_to?: Date;
  status?: 'PENDING' | 'CONFIRMED' | 'CANCELLED' | 'COMPLETED';
  notes?: string;
  // Joined fields
  location_name?: string;
  station_name?: string;
  client_name?: string;
  user_name?: string;
  vehicle_type_name?: string;
  created_at?: Date;
  updated_at?: Date;
}

export class Reservation implements IReservation {
  id_reservation?: number;
  id_location: number = 0;
  id_station: number = 0;
  id_client?: number;
  id_user?: number;
  id_vehicle_type: number = 1;
  license_plate: string = '';
  duration_minutes: number = 60;
  energy_kwh?: number;
  date_from: Date = null as any;
  date_to?: Date;
  status?: 'PENDING' | 'CONFIRMED' | 'CANCELLED' | 'COMPLETED' = 'CONFIRMED';
  notes?: string;
  location_name?: string;
  station_name?: string;
  client_name?: string;
  user_name?: string;
  vehicle_type_name?: string;
  created_at?: Date;
  updated_at?: Date;

  constructor(data?: Partial<IReservation> | any) {
    if (data) {
      Object.assign(this, data);
      // Konverze stringů z BE na Date.
      if (data.date_from && !(this.date_from instanceof Date)) this.date_from = new Date(data.date_from);
      if (data.date_to && !(this.date_to instanceof Date)) this.date_to = new Date(data.date_to);
      if (data.created_at && !(this.created_at instanceof Date)) this.created_at = new Date(data.created_at);
      if (data.updated_at && !(this.updated_at instanceof Date)) this.updated_at = new Date(data.updated_at);
    }
  }

  static fromArray(arr: any[]): Reservation[] {
    return arr.map(item => new Reservation(item));
  }

  get statusLabel(): string {
    const labels: Record<string, string> = {
      'PENDING': 'Čeká na potvrzení',
      'CONFIRMED': 'Potvrzeno',
      'CANCELLED': 'Zrušeno',
      'COMPLETED': 'Dokončeno'
    };
    return labels[this.status || 'CONFIRMED'] || this.status || '';
  }

  get durationHours(): number {
    return Math.ceil((this.duration_minutes || 0) / 60);
  }
}

export interface IDurationOption {
  duration_minutes: number;
  label: string;
}

export interface IVehicleType {
  id_vehicle_type: number;
  name: string;
  avg_charging_power_kw: number;
}
